import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const Defaults = lazy(() => import("../default/pages/Defaults"));
const Configuration = lazy(() => import("../configuration/pages/Configuration"));
const ListsOptions = lazy(() => import("../formAndTemplates/listsOptions/pages/ListsOptions"));

export const settingsRoute = [
  {
    path: "/settings",
    children: [
      {
        index: true,
        element: <Navigate to="defaults" replace />,
      },
      {
        path: "defaults",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Defaults />
          </Suspense>
        ),
      },
       {
        path: "configuration",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Configuration />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/forms-templates",
    children: [
      {
        index: true,
        element: <Navigate to="lists-options" replace />,
      },
      {
        path: "lists-options",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ListsOptions />
          </Suspense>
        ),
      },
    ],
  },
];
